/**
 * neo 스킨 — 글래스모피즘.
 *
 * 감성 키워드:
 * - 반투명 카드 + backdrop-filter blur
 * - 미묘한 테두리(반투명 흰색)
 * - 다크모드에서 특히 효과 좋음
 *
 * 브라우저 호환: backdrop-filter 미지원 시 overlay CSS 의 @supports fallback 참조
 *
 * CSS overlay 위치: styles/skins.css — `body[data-skin="neo"]` 블록
 */
import type { SkinDef } from './types'

export const neoSkin: SkinDef = {
  key: 'neo',
  label: '네오',
  description: '글래스모피즘 (다크모드 권장)',
  swatch: { bg: '#1e1e28', fg: '#e2e8f0', accent: '#7dd3fc' },
  token: {
    borderRadius: 12,
    borderRadiusLG: 16,
    borderRadiusSM: 8
  },
  componentDefaults: {
    Card: {
      borderRadiusLG: 16
    },
    Button: {
      borderRadius: 12
    }
  }
}
